(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@angular/common'), require('rxjs'), require('rxjs/operators'), require('@material/floating-label'), require('@material/line-ripple'), require('@material/notched-outline'), require('@angular/cdk/coercion'), require('@angular/cdk/platform'), require('@material/menu-surface'), require('@angular/cdk/keycodes'), require('@material/ripple'), require('@material/list'), require('@material/menu'), require('@angular/forms'), require('@material/select')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/mdc-test-web/select', ['exports', '@angular/core', '@angular/common', 'rxjs', 'rxjs/operators', '@material/floating-label', '@material/line-ripple', '@material/notched-outline', '@angular/cdk/coercion', '@angular/cdk/platform', '@material/menu-surface', '@angular/cdk/keycodes', '@material/ripple', '@material/list', '@material/menu', '@angular/forms', '@material/select'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.mdcTestWeb = global.shraddhar.mdcTestWeb || {}, global.shraddhar.mdcTestWeb.select = {}), global.ng.core, global.ng.common, global.rxjs, global.rxjs.operators, global.mdc.floatingLabel, global.mdc.lineRipple, global.mdc.notchedOutline, global.ng.cdk.coercion, global.ng.cdk.platform, global.mdc.menuSurface, global.ng.cdk.keycodes, global.mdc.ripple, global.mdc.list, global.mdc.menu, global.ng.forms, global.mdc.select));
}(this, (function (exports, i0, common, rxjs, operators, floatingLabel, lineRipple, notchedOutline, coercion, platform, menuSurface, keycodes, ripple, list, menu, forms, select) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MDCComponent = /** @class */ (function () {
        function MDCComponent(elementRef, foundation) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            this._elementRef = elementRef;
            this.initialize.apply(this, __spread(args));
            // Note that we initialize foundation here and not within the constructor's default param.
            this._foundation = foundation === undefined ? this.getDefaultFoundation() : foundation;
        }
        /* istanbul ignore next: method param only exists for typing purposes; it does not need to be unit tested */
        MDCComponent.prototype.initialize = function () {
            var _args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                _args[_i] = arguments[_i];
            }
            // Subclasses can override this to do any additional setup work that would be considered part of a
            // "constructor". Essentially, it is a hook into the parent constructor before the foundation is
            // initialized. Any additional arguments besides root and foundation will be passed in here.
        };
        MDCComponent.prototype.getDefaultFoundation = function () {
            // Subclasses must override this method to return a properly configured foundation class for the
            // component.
            throw new Error('Subclasses must override getDefaultFoundation to return a properly configured ' +
                'foundation class');
        };
        MDCComponent.prototype.destroy = function () {
            var _a;
            // Subclasses may implement this method to release any resources / deregister any listeners they have
            // attached. An example of this might be deregistering a resize event from the window object.
            (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.destroy();
        };
        return MDCComponent;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcFloatingLabel = /** @class */ (function (_super) {
        __extends(MdcFloatingLabel, _super);
        function MdcFloatingLabel(_ngZone, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._ngZone = _ngZone;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            return _this;
        }
        MdcFloatingLabel.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                getWidth: function () { return _this._getHostElement().scrollWidth; },
                registerInteractionHandler: function () { },
                deregisterInteractionHandler: function () { }
            };
            return new floatingLabel.MDCFloatingLabelFoundation(adapter);
        };
        MdcFloatingLabel.prototype.ngAfterContentInit = function () {
            this._loadListeners();
        };
        MdcFloatingLabel.prototype.ngOnDestroy = function () {
            this._destroy.next();
            this._destroy.complete();
        };
        /** Returns the width of the label element. */
        MdcFloatingLabel.prototype.getWidth = function () {
            return this._foundation.getWidth();
        };
        /** Styles the label to produce the label shake for errors. */
        MdcFloatingLabel.prototype.shake = function (shouldShake) {
            this._foundation.shake(shouldShake);
        };
        /** Styles the label to float or dock. */
        MdcFloatingLabel.prototype.float = function (shouldFloat) {
            this._foundation.float(shouldFloat);
        };
        MdcFloatingLabel.prototype._loadListeners = function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this._getHostElement(), 'animationend')
                    .pipe(operators.takeUntil(_this._destroy), operators.filter(function (e) {
                    return e.target === _this._getHostElement();
                }))
                    .subscribe(function () { return _this._ngZone.run(function () { return _this._getHostElement().classList.remove(floatingLabel.cssClasses.LABEL_SHAKE); }); });
            });
        };
        /** Retrieves the DOM element of the component host. */
        MdcFloatingLabel.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcFloatingLabel.decorators = [
            { type: i0.Directive, args: [{
                        selector: 'label[mdcFloatingLabel], mdc-floating-label',
                        exportAs: 'mdcFloatingLabel',
                        host: {
                            'class': 'mdc-floating-label',
                            '[for]': 'for'
                        }
                    },] }
        ];
        /** @nocollapse */
        MdcFloatingLabel.ctorParameters = function () { return [
            { type: i0.NgZone },
            { type: i0.ElementRef }
        ]; };
        MdcFloatingLabel.propDecorators = {
            for: [{ type: i0.Input }]
        };
        return MdcFloatingLabel;
    }(MDCComponent));

    var MdcFloatingLabelModule = /** @class */ (function () {
        function MdcFloatingLabelModule() {
        }
        MdcFloatingLabelModule.decorators = [
            { type: i0.NgModule, args: [{
                        exports: [MdcFloatingLabel],
                        declarations: [MdcFloatingLabel]
                    },] }
        ];
        return MdcFloatingLabelModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcLineRipple = /** @class */ (function (_super) {
        __extends(MdcLineRipple, _super);
        function MdcLineRipple(_ngZone, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._ngZone = _ngZone;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            return _this;
        }
        MdcLineRipple.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                hasClass: function (className) { return _this._getHostElement().classList.contains(className); },
                setStyle: function (propertyName, value) { return _this._getHostElement().style.setProperty(propertyName, value); },
                registerEventHandler: function () { },
                deregisterEventHandler: function () { }
            };
            return new lineRipple.MDCLineRippleFoundation(adapter);
        };
        MdcLineRipple.prototype.ngOnInit = function () {
            this._loadListeners();
        };
        MdcLineRipple.prototype.destroy = function () {
            this._destroy.next();
            this._destroy.complete();
        };
        MdcLineRipple.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        /** Activates the line ripple */
        MdcLineRipple.prototype.activate = function () {
            this._foundation.activate();
        };
        /** Deactivates the line ripple */
        MdcLineRipple.prototype.deactivate = function () {
            this._foundation.deactivate();
        };
        /**
         * Sets the transform origin given a user's click location.
         * The `rippleCenter` is the x-coordinate of the middle of the ripple.
         */
        MdcLineRipple.prototype.setRippleCenter = function (xCoordinate) {
            this._foundation.setRippleCenter(xCoordinate);
        };
        MdcLineRipple.prototype._loadListeners = function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this._getHostElement(), 'transitionend')
                    .pipe(operators.takeUntil(_this._destroy), operators.filter(function (e) {
                    return e.target === _this._getHostElement();
                }))
                    .subscribe(function (evt) { return _this._ngZone.run(function () { return _this._foundation.handleTransitionEnd(evt); }); });
            });
        };
        /** Retrieves the DOM element of the component host. */
        MdcLineRipple.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcLineRipple.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcLineRipple], mdc-line-ripple',
                        exportAs: 'mdcLineRipple',
                        host: { 'class': 'mdc-line-ripple' }
                    },] }
        ];
        /** @nocollapse */
        MdcLineRipple.ctorParameters = function () { return [
            { type: i0.NgZone },
            { type: i0.ElementRef }
        ]; };
        return MdcLineRipple;
    }(MDCComponent));

    var MdcLineRippleModule = /** @class */ (function () {
        function MdcLineRippleModule() {
        }
        MdcLineRippleModule.decorators = [
            { type: i0.NgModule, args: [{
                        exports: [MdcLineRipple],
                        declarations: [MdcLineRipple]
                    },] }
        ];
        return MdcLineRippleModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcNotchedOutline = /** @class */ (function (_super) {
        __extends(MdcNotchedOutline, _super);
        function MdcNotchedOutline(elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this.elementRef = elementRef;
            return _this;
        }
        MdcNotchedOutline.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this.elementRef.nativeElement.classList.add(className); },
                removeClass: function (className) {
                    return _this.elementRef.nativeElement.classList.remove(className);
                },
                setNotchWidthProperty: function (width) {
                    return _this._notchElement.nativeElement.style.setProperty('width', width + "px");
                },
                removeNotchWidthProperty: function () { return _this._notchElement.nativeElement.style.removeProperty('width'); }
            };
            return new notchedOutline.MDCNotchedOutlineFoundation(adapter);
        };
        /** Updates classes and styles to open the notch to the specified width. */
        MdcNotchedOutline.prototype.notch = function (notchWidth) {
            this._foundation.notch(notchWidth);
        };
        /** Updates classes and styles to close the notch. */
        MdcNotchedOutline.prototype.closeNotch = function () {
            this._foundation.closeNotch();
        };
        MdcNotchedOutline.decorators = [
            { type: i0.Component, args: [{
                        selector: '[mdcNotchedOutline], mdc-notched-outline',
                        exportAs: 'mdcNotchedOutline',
                        host: {
                            'class': 'mdc-notched-outline',
                            '[class.mdc-notched-outline--upgraded]': 'label',
                            '[class.mdc-notched-outline--no-label]': '!label'
                        },
                        template: "<span class=\"mdc-notched-outline__leading\"></span>\r\n<span #notch class=\"mdc-notched-outline__notch\">\r\n  <label mdcFloatingLabel [for]=\"for\" *ngIf=\"!!label\">{{label}}</label>\r\n</span>\r\n<span class=\"mdc-notched-outline__trailing\"></span>",
                        changeDetection: i0.ChangeDetectionStrategy.OnPush,
                        encapsulation: i0.ViewEncapsulation.None
                    }] }
        ];
        /** @nocollapse */
        MdcNotchedOutline.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        MdcNotchedOutline.propDecorators = {
            label: [{ type: i0.Input }],
            for: [{ type: i0.Input }],
            _notchElement: [{ type: i0.ViewChild, args: ['notch', { static: false },] }],
            floatingLabel: [{ type: i0.ViewChild, args: [MdcFloatingLabel, { static: false },] }]
        };
        return MdcNotchedOutline;
    }(MDCComponent));

    var MdcNotchedOutlineModule = /** @class */ (function () {
        function MdcNotchedOutlineModule() {
        }
        MdcNotchedOutlineModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [common.CommonModule, MdcFloatingLabelModule],
                        exports: [MdcNotchedOutline],
                        declarations: [MdcNotchedOutline]
                    },] }
        ];
        return MdcNotchedOutlineModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcFormFieldControl = /** @class */ (function () {
        function MdcFormFieldControl() {
            /** The value of the control. */
            this.value = null;
        }
        return MdcFormFieldControl;
    }());

    var MdcFormField = /** @class */ (function () {
        function MdcFormField(_ngZone, elementRef) {
            this._ngZone = _ngZone;
            this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            this._destroy = new rxjs.Subject();
            this._fluid = false;
            this._alignEnd = false;
            this._nowrap = false;
            this._spaceBetween = false;
        }
        Object.defineProperty(MdcFormField.prototype, "fluid", {
            get: function () {
                return this._fluid;
            },
            set: function (value) {
                this._fluid = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcFormField.prototype, "alignEnd", {
            get: function () {
                return this._alignEnd;
            },
            set: function (value) {
                this._alignEnd = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcFormField.prototype, "nowrap", {
            get: function () {
                return this._nowrap;
            },
            set: function (value) {
                this._nowrap = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcFormField.prototype, "spaceBetween", {
            get: function () {
                return this._spaceBetween;
            },
            set: function (value) {
                this._spaceBetween = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcFormField.prototype.ngAfterContentInit = function () {
            var _a;
            if (this._control) {
                var control = this._control.elementRef.nativeElement;
                if (((_a = control === null || control === void 0 ? void 0 : control.nextElementSibling) === null || _a === void 0 ? void 0 : _a.tagName) === 'LABEL') {
                    this.label = control.nextElementSibling;
                    if (this.label && this._control.inputId) {
                        this.label.setAttribute('for', this._control.inputId);
                        this._loadListeners();
                    }
                }
            }
        };
        MdcFormField.prototype.ngOnDestroy = function () {
            this._destroy.next();
            this._destroy.complete();
        };
        MdcFormField.prototype._loadListeners = function () {
            var _this = this;
            this._ngZone.runOutsideAngular(function () {
                return rxjs.fromEvent(_this.label, 'click').pipe(operators.takeUntil(_this._destroy))
                    .subscribe(function () { return _this._ngZone.run(function () {
                    _this._control.ripple.activateRipple();
                    if (typeof requestAnimationFrame !== 'undefined') {
                        requestAnimationFrame(function () { return _this._control.ripple.deactivateRipple(); });
                    }
                }); });
            });
        };
        MdcFormField.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-form-field',
                        exportAs: 'mdcFormField',
                        host: {
                            '[class.ngx-mdc-form-field--fluid]': 'fluid',
                            '[class.mdc-form-field--align-end]': 'alignEnd',
                            '[class.mdc-form-field--nowrap]': 'nowrap',
                            '[class.mdc-form-field--space-between]': 'spaceBetween',
                        },
                        template: "<ng-content></ng-content>\r\n<ng-content select=\"[mdcHelperText, mdc-helper-text]\"></ng-content>",
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcFormField.ctorParameters = function () { return [
            { type: i0.NgZone },
            { type: i0.ElementRef }
        ]; };
        MdcFormField.propDecorators = {
            fluid: [{ type: i0.Input }],
            alignEnd: [{ type: i0.Input }],
            nowrap: [{ type: i0.Input }],
            spaceBetween: [{ type: i0.Input }],
            _control: [{ type: i0.ContentChild, args: [MdcFormFieldControl, { static: false },] }]
        };
        return MdcFormField;
    }());

    var FORM_FIELD_DECLARATIONS = [
        MdcFormField,
    ];
    var MdcFormFieldModule = /** @class */ (function () {
        function MdcFormFieldModule() {
        }
        MdcFormFieldModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: [FORM_FIELD_DECLARATIONS],
                        declarations: [FORM_FIELD_DECLARATIONS]
                    },] }
        ];
        return MdcFormFieldModule;
    }());

    /**
     * Mixin to augment a directive with updateErrorState method.
     * For component with `errorState` and need to update `errorState`.
     */
    function mixinErrorState(base) {
        return /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = _super.apply(this, __spread(args)) || this;
                /** Whether the component is in an error state. */
                _this.errorState = false;
                _this.required = false;
                return _this;
            }
            class_1.prototype.updateErrorState = function () {
                var oldState = this.errorState;
                var parent = this._parentFormGroup || this._parentForm;
                var matcher = this.errorStateMatcher || this._defaultErrorStateMatcher;
                var control = this.ngControl ? this.ngControl.control : null;
                var newState = matcher.isErrorState(control, parent);
                if (newState !== oldState) {
                    this.errorState = newState;
                }
                // Currently there isn't a great way to determine if Validators.required
                // has been added to the control since form validators are combined into
                // an aggregate function at initialization.
                if (control && !this.required) {
                    this.required = control.hasError('required');
                }
            };
            return class_1;
        }(base));
    }

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    /** Provider that defines how form controls behave with regards to displaying error messages. */
    var ErrorStateMatcher = /** @class */ (function () {
        function ErrorStateMatcher() {
        }
        ErrorStateMatcher.prototype.isErrorState = function (control, form) {
            return !!(control && control.invalid && (control.touched || (form && form.submitted)));
        };
        ErrorStateMatcher.decorators = [
            { type: i0.Injectable, args: [{ providedIn: 'root' },] }
        ];
        ErrorStateMatcher.ɵprov = i0.ɵɵdefineInjectable({ factory: function ErrorStateMatcher_Factory() { return new ErrorStateMatcher(); }, token: ErrorStateMatcher, providedIn: "root" });
        return ErrorStateMatcher;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var ANCHOR_CORNER_MAP = {
        topEnd: menuSurface.Corner.TOP_END,
        topStart: menuSurface.Corner.TOP_START,
        bottomEnd: menuSurface.Corner.BOTTOM_END,
        bottomStart: menuSurface.Corner.BOTTOM_START
    };
    var MdcMenuSurfaceBase = /** @class */ (function (_super) {
        __extends(MdcMenuSurfaceBase, _super);
        function MdcMenuSurfaceBase(changeDetectorRef, platform, _ngZone, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this.changeDetectorRef = changeDetectorRef;
            _this.platform = platform;
            _this._ngZone = _ngZone;
            _this.elementRef = elementRef;
            /** Emits whenever the component is destroyed. */
            _this._destroy = new rxjs.Subject();
            _this._open = false;
            _this._anchorCorner = 'topStart';
            _this._quickOpen = false;
            _this._fixed = false;
            _this._coordinates = { x: 0, y: 0 };
            _this._anchorMargin = {};
            _this._hoistToBody = false;
            /** Emits an event whenever the menu surface is opened. */
            _this.opened = new i0.EventEmitter();
            /** Emits an event whenever the menu surface is closed. */
            _this.closed = new i0.EventEmitter();
            /** Subscription to interaction events in menu-surface. */
            _this._windowClickSubscription = null;
            return _this;
        }
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "open", {
            get: function () {
                return this._open;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._open) {
                    this._open = coercion.coerceBooleanProperty(value);
                    if (this._open) {
                        this._foundation.open();
                    }
                    else {
                        this._foundation.close();
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "anchorElement", {
            get: function () {
                return this._anchorElement;
            },
            set: function (element) {
                this._anchorElement = element;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "anchorCorner", {
            get: function () {
                return this._anchorCorner;
            },
            set: function (value) {
                this._anchorCorner = value !== null && value !== void 0 ? value : 'topStart';
                this._foundation.setAnchorCorner(ANCHOR_CORNER_MAP[this._anchorCorner]);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "quickOpen", {
            get: function () {
                return this._quickOpen;
            },
            set: function (value) {
                this._quickOpen = coercion.coerceBooleanProperty(value);
                this._foundation.setQuickOpen(this._quickOpen);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "fixed", {
            get: function () {
                return this._fixed;
            },
            set: function (value) {
                this._fixed = coercion.coerceBooleanProperty(value);
                if (this._fixed) {
                    this._getHostElement().classList.add('mdc-menu-surface--fixed');
                }
                else {
                    this._getHostElement().classList.remove('mdc-menu-surface--fixed');
                }
                this._foundation.setFixedPosition(this._fixed);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "coordinates", {
            get: function () {
                return this._coordinates;
            },
            set: function (value) {
                this._coordinates = value;
                this._foundation.setAbsolutePosition(value.x, value.y);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "anchorMargin", {
            get: function () {
                return this._anchorMargin;
            },
            set: function (value) {
                this._anchorMargin = value;
                this._foundation.setAnchorMargin(this._anchorMargin);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenuSurfaceBase.prototype, "hoistToBody", {
            get: function () {
                return this._hoistToBody;
            },
            set: function (value) {
                this._hoistToBody = coercion.coerceBooleanProperty(value);
                if (this._hoistToBody) {
                    this.setHoistToBody();
                }
            },
            enumerable: true,
            configurable: true
        });
        MdcMenuSurfaceBase.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._getHostElement().classList.add(className); },
                removeClass: function (className) { return _this._getHostElement().classList.remove(className); },
                hasClass: function (className) { return _this._getHostElement().classList.contains(className); },
                hasAnchor: function () { return !!_this.anchorElement; },
                notifyClose: function () {
                    _this.closed.emit();
                    _this._deregisterWindowClickListener();
                },
                notifyOpen: function () {
                    _this.opened.emit();
                    _this._registerWindowClickListener();
                },
                isElementInContainer: function (el) { return _this._getHostElement() === el || _this._getHostElement().contains(el); },
                isRtl: function () { return _this.platform.isBrowser ?
                    window.getComputedStyle(_this._getHostElement()).getPropertyValue('direction') === 'rtl' : false; },
                setTransformOrigin: function (origin) {
                    return _this.platform.isBrowser ?
                        _this._getHostElement().style[menuSurface.util.getTransformPropertyName(window) + "-origin"] = origin : false;
                },
                isFocused: function () { var _a; return (_a = (document === null || document === void 0 ? void 0 : document.activeElement) === _this._getHostElement()) !== null && _a !== void 0 ? _a : false; },
                saveFocus: function () { var _a; return _this._previousFocus = (_a = document === null || document === void 0 ? void 0 : document.activeElement) !== null && _a !== void 0 ? _a : undefined; },
                restoreFocus: function () {
                    var _a;
                    if (_this.platform.isBrowser) {
                        if (_this._getHostElement().contains(document.activeElement)) {
                            (_a = _this._previousFocus) === null || _a === void 0 ? void 0 : _a.focus();
                        }
                    }
                },
                getInnerDimensions: function () {
                    return ({ width: _this._getHostElement().offsetWidth, height: _this._getHostElement().offsetHeight });
                },
                getAnchorDimensions: function () {
                    return _this.platform.isBrowser || !_this.anchorElement ?
                        _this._anchorElement.getBoundingClientRect() : { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
                },
                getWindowDimensions: function () { return ({
                    width: _this.platform.isBrowser ? window.innerWidth : 0,
                    height: _this.platform.isBrowser ? window.innerHeight : 0
                }); },
                getBodyDimensions: function () { return ({
                    width: _this.platform.isBrowser ? document.body.clientWidth : 0,
                    height: _this.platform.isBrowser ? document.body.clientHeight : 0
                }); },
                getWindowScroll: function () { return ({
                    x: _this.platform.isBrowser ? window.pageXOffset : 0,
                    y: _this.platform.isBrowser ? window.pageYOffset : 0
                }); },
                setPosition: function (position) {
                    _this._getHostElement().style.left = 'left' in position ? position.left + "px" : '';
                    _this._getHostElement().style.right = 'right' in position ? position.right + "px" : '';
                    _this._getHostElement().style.top = 'top' in position ? position.top + "px" : '';
                    _this._getHostElement().style.bottom = 'bottom' in position ? position.bottom + "px" : '';
                },
                setMaxHeight: function (height) { return _this._getHostElement().style.maxHeight = height; }
            };
            return new menuSurface.MDCMenuSurfaceFoundation(adapter);
        };
        MdcMenuSurfaceBase.prototype.initMenuSurface = function () {
            var _a;
            this._foundation.init();
            this.anchorElement = (_a = this._getHostElement().parentElement) !== null && _a !== void 0 ? _a : this.anchorElement;
            this._registerKeydownListener();
        };
        MdcMenuSurfaceBase.prototype.destroyMenuSurface = function () {
            this._destroy.next();
            this._destroy.complete();
            this._deregisterWindowClickListener();
            // add platform check due to use of cancelAnimationFrame inside destroy()
            if (this.platform.isBrowser) {
                this._foundation.destroy();
            }
            if (this.hoistToBody) {
                document.body.removeChild(this._getHostElement());
            }
        };
        /**
         * Removes the menu-surface from it's current location and appends it to the
         * body to overcome any overflow:hidden issues.
         */
        MdcMenuSurfaceBase.prototype.setHoistToBody = function () {
            if (!this.platform.isBrowser) {
                return;
            }
            var parentEl = this._getHostElement().parentElement;
            if (parentEl) {
                document.body.appendChild(parentEl.removeChild(this._getHostElement()));
                this._foundation.setIsHoisted(true);
            }
        };
        MdcMenuSurfaceBase.prototype._registerKeydownListener = function () {
            var _this = this;
            rxjs.fromEvent(this._getHostElement(), 'keydown')
                .pipe(operators.takeUntil(this._destroy))
                .subscribe(function (evt) {
                _this._foundation.handleKeydown(evt);
                _this._open = _this._foundation.isOpen();
            });
        };
        MdcMenuSurfaceBase.prototype._registerWindowClickListener = function () {
            var _this = this;
            if (!this.platform.isBrowser) {
                return;
            }
            this._windowClickSubscription =
                this._ngZone.runOutsideAngular(function () {
                    return rxjs.fromEvent(window, 'click')
                        .subscribe(function (evt) { return _this._ngZone.run(function () {
                        _this._foundation.handleBodyClick(evt);
                        _this._open = _this._foundation.isOpen();
                    }); });
                });
        };
        MdcMenuSurfaceBase.prototype._deregisterWindowClickListener = function () {
            var _a;
            (_a = this._windowClickSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        };
        /** Retrieves the DOM element of the component host. */
        MdcMenuSurfaceBase.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcMenuSurfaceBase.decorators = [
            { type: i0.Directive }
        ];
        /** @nocollapse */
        MdcMenuSurfaceBase.ctorParameters = function () { return [
            { type: i0.ChangeDetectorRef },
            { type: platform.Platform },
            { type: i0.NgZone, decorators: [{ type: i0.Optional }] },
            { type: i0.ElementRef }
        ]; };
        MdcMenuSurfaceBase.propDecorators = {
            open: [{ type: i0.Input }],
            anchorElement: [{ type: i0.Input }],
            anchorCorner: [{ type: i0.Input }],
            quickOpen: [{ type: i0.Input }],
            fixed: [{ type: i0.Input }],
            coordinates: [{ type: i0.Input }],
            anchorMargin: [{ type: i0.Input }],
            hoistToBody: [{ type: i0.Input }],
            opened: [{ type: i0.Output }],
            closed: [{ type: i0.Output }]
        };
        return MdcMenuSurfaceBase;
    }(MDCComponent));

    var MdcMenuSurface = /** @class */ (function (_super) {
        __extends(MdcMenuSurface, _super);
        function MdcMenuSurface() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        MdcMenuSurface.prototype.ngOnInit = function () {
            this.initMenuSurface();
        };
        MdcMenuSurface.prototype.ngOnDestroy = function () {
            this.destroyMenuSurface();
        };
        MdcMenuSurface.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-menu-surface',
                        exportAs: 'mdcMenuSurface',
                        host: { 'class': 'mdc-menu-surface' },
                        template: '<ng-content></ng-content>',
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        return MdcMenuSurface;
    }(MdcMenuSurfaceBase));

    var MdcMenuSurfaceAnchor = /** @class */ (function () {
        function MdcMenuSurfaceAnchor(elementRef) {
            this.elementRef = elementRef;
        }
        MdcMenuSurfaceAnchor.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcMenuSurfaceAnchor], mdc-menu-surface-anchor',
                        host: { 'class': 'mdc-menu-surface--anchor' }
                    },] }
        ];
        /** @nocollapse */
        MdcMenuSurfaceAnchor.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        return MdcMenuSurfaceAnchor;
    }());

    var MENU_SURFACE_DECLARATIONS = [
        MdcMenuSurface,
        MdcMenuSurfaceAnchor
    ];
    var MdcMenuSurfaceModule = /** @class */ (function () {
        function MdcMenuSurfaceModule() {
        }
        MdcMenuSurfaceModule.decorators = [
            { type: i0.NgModule, args: [{
                        exports: [MENU_SURFACE_DECLARATIONS],
                        declarations: [MENU_SURFACE_DECLARATIONS]
                    },] }
        ];
        return MdcMenuSurfaceModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcListDivider = /** @class */ (function () {
        function MdcListDivider(elementRef) {
            this.elementRef = elementRef;
            this._inset = false;
            this._padded = false;
        }
        Object.defineProperty(MdcListDivider.prototype, "inset", {
            get: function () {
                return this._inset;
            },
            set: function (value) {
                this._inset = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcListDivider.prototype, "padded", {
            get: function () {
                return this._padded;
            },
            set: function (value) {
                this._padded = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcListDivider.decorators = [
            { type: i0.Component, args: [{
                        selector: '[mdcListDivider], mdc-list-divider',
                        exportAs: 'mdcListDivider',
                        host: {
                            'role': 'separator',
                            'class': 'mdc-list-divider',
                            '[class.mdc-list-divider--inset]': 'inset',
                            '[class.mdc-list-divider--padded]': 'padded'
                        },
                        template: '',
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcListDivider.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        MdcListDivider.propDecorators = {
            inset: [{ type: i0.Input }],
            padded: [{ type: i0.Input }]
        };
        return MdcListDivider;
    }());

    /**
     * @license
     * Copyright Google LLC All Rights Reserved.
     *
     * Use of this source code is governed by an MIT-style license that can be
     * found in the LICENSE file at https://angular.io/license
     */
    var hasNativeClosest = typeof Element !== 'undefined' && !!Element.prototype.closest;
    /** IE 11 compatible closest implementation that is able to start from non-Element Nodes. */
    function closest(element, selector) {
        if (!(element instanceof Node)) {
            return null;
        }
        var curr = element;
        while (curr != null && !(curr instanceof Element)) {
            curr = curr.parentNode;
        }
        return curr && (hasNativeClosest ?
            curr.closest(selector) : polyfillClosest(curr, selector));
    }
    /** Polyfill for browsers without Element.closest. */
    function polyfillClosest(element, selector) {
        var curr = element;
        while (curr != null && !(curr instanceof Element && matches(curr, selector))) {
            curr = curr.parentNode;
        }
        return (curr || null);
    }
    /** IE 11 compatible matches implementation. */
    function matches(element, selector) {
        return element.matches ?
            element.matches(selector) :
            element['msMatchesSelector'](selector);
    }

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcRipple = /** @class */ (function () {
        function MdcRipple(element, foundation) {
            this.element = element;
            this.initialized = false;
            this._foundation = foundation || new ripple.MDCRippleFoundation(MdcRipple.createAdapter({
                _root: element.nativeElement
            }));
        }
        MdcRipple.createAdapter = function (instance) {
            var adapter = {
                addClass: function (className) { return instance._root.classList.add(className); },
                removeClass: function (className) { return instance._root.classList.remove(className); },
                browserSupportsCssVars: function () { return typeof window !== 'undefined' ? ripple.util.supportsCssVariables(window) : false; },
                isUnbounded: function () { return coercion.coerceBooleanProperty(instance.unbounded); },
                isSurfaceActive: function () { return matches(instance._root, ':active'); },
                isSurfaceDisabled: function () { return coercion.coerceBooleanProperty(instance.disabled); },
                containsEventTarget: function (target) { return instance._root.contains(target); },
                registerDocumentInteractionHandler: function (evtType, handler) {
                    return typeof document === 'object' && !!document ?
                        document.documentElement.addEventListener(evtType, handler, platform.supportsPassiveEventListeners()) : {};
                },
                deregisterDocumentInteractionHandler: function (evtType, handler) {
                    return typeof document === 'object' && !!document ?
                        document.documentElement.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners()) : {};
                },
                registerResizeHandler: function (handler) { return typeof window !== 'undefined' ?
                    window.addEventListener('resize', handler) : {}; },
                deregisterResizeHandler: function (handler) { return typeof window !== 'undefined' ?
                    window.removeEventListener('resize', handler) : {}; },
                updateCssVariable: function (varName, value) {
                    return instance._root.style.setProperty(varName, value);
                },
                computeBoundingRect: function () { return typeof document === 'object' && !!document ?
                    instance._root.getBoundingClientRect() : ({ top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }); },
                getWindowPageOffset: function () { return typeof window !== 'undefined' ?
                    ({ x: window.pageXOffset, y: window.pageYOffset }) : ({ x: 0, y: 0 }); },
                registerInteractionHandler: function (evtType, handler) {
                    return instance._root.addEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                },
                deregisterInteractionHandler: function (evtType, handler) {
                    return instance._root.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners());
                }
            };
            return adapter;
        };
        MdcRipple.prototype.init = function () {
            if (!this.initialized) {
                this._foundation.init();
                this.initialized = true;
            }
        };
        MdcRipple.prototype.destroy = function () {
            if (this.initialized) {
                this.initialized = false;
                this._foundation.destroy();
            }
        };
        MdcRipple.prototype.layout = function () {
            this._foundation.layout();
        };
        MdcRipple.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        MdcRipple.prototype.activateRipple = function (event) {
            var _this = this;
            setTimeout(function () { return _this._foundation.activate(event); });
        };
        MdcRipple.prototype.deactivateRipple = function () {
            var _this = this;
            setTimeout(function () { return _this._foundation.deactivate(); });
        };
        MdcRipple.prototype.handleBlur = function () {
            this._foundation.handleBlur();
        };
        MdcRipple.decorators = [
            { type: i0.Injectable }
        ];
        /** @nocollapse */
        MdcRipple.ctorParameters = function () { return [
            { type: i0.ElementRef },
            { type: ripple.MDCRippleFoundation, decorators: [{ type: i0.Optional }] }
        ]; };
        return MdcRipple;
    }());

    var MdcRippleDirective = /** @class */ (function () {
        function MdcRippleDirective(_ripple, elementRef) {
            this._ripple = _ripple;
            this.elementRef = elementRef;
            this._primary = false;
            this._secondary = false;
            this._disabled = false;
            this._unbounded = false;
            this._root = this.elementRef.nativeElement;
            this._ripple = this._createRipple();
        }
        Object.defineProperty(MdcRippleDirective.prototype, "attachTo", {
            get: function () {
                return this._attachTo;
            },
            set: function (element) {
                var _a, _b;
                this._attachTo = element;
                (_b = (_a = this._attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add('mdc-ripple-surface');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "primary", {
            get: function () {
                return this._primary;
            },
            set: function (value) {
                this._primary = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "secondary", {
            get: function () {
                return this._secondary;
            },
            set: function (value) {
                this._secondary = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this._disabled = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcRippleDirective.prototype, "unbounded", {
            get: function () {
                return this._unbounded;
            },
            set: function (value) {
                this._unbounded = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        MdcRippleDirective.prototype.ngOnChanges = function (changes) {
            if (changes['primary'] && this.attachTo) {
                if (this._primary) {
                    this.attachTo.classList.add('mdc-ripple-surface--primary');
                }
                else {
                    this.attachTo.classList.remove('mdc-ripple-surface--primary');
                }
            }
            if (changes['secondary'] && this.attachTo) {
                if (this._secondary) {
                    this.attachTo.classList.add('mdc-ripple-surface--accent');
                }
                else {
                    this.attachTo.classList.remove('mdc-ripple-surface--accent');
                }
            }
        };
        MdcRippleDirective.prototype.ngAfterViewInit = function () {
            this._ripple.init();
        };
        MdcRippleDirective.prototype.ngOnDestroy = function () {
            this._ripple.destroy();
        };
        MdcRippleDirective.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, MdcRipple.createAdapter(this)), { addClass: function (className) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.add(className); }, computeBoundingRect: function () { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) !== null && _b !== void 0 ? _b : ({ top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }); }, isSurfaceActive: function () { return matches(_this.attachTo, ':active'); }, isSurfaceDisabled: function () { return _this._disabled; }, isUnbounded: function () { return _this._unbounded; }, removeClass: function (className) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove(className); }, updateCssVariable: function (varName, value) { var _a, _b; return (_b = (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.setProperty(varName, value); }, registerInteractionHandler: function (evtType, handler) { var _a; return (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.addEventListener(evtType, handler, platform.supportsPassiveEventListeners()); }, deregisterInteractionHandler: function (evtType, handler) { var _a; return (_a = _this.attachTo) === null || _a === void 0 ? void 0 : _a.removeEventListener(evtType, handler, platform.supportsPassiveEventListeners()); } });
            return new MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcRippleDirective.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcRipple], mdc-ripple',
                        providers: [MdcRipple],
                    },] }
        ];
        /** @nocollapse */
        MdcRippleDirective.ctorParameters = function () { return [
            { type: MdcRipple },
            { type: i0.ElementRef }
        ]; };
        MdcRippleDirective.propDecorators = {
            attachTo: [{ type: i0.Input }],
            primary: [{ type: i0.Input }],
            secondary: [{ type: i0.Input }],
            disabled: [{ type: i0.Input }],
            unbounded: [{ type: i0.Input }]
        };
        return MdcRippleDirective;
    }());

    var MdcRippleModule = /** @class */ (function () {
        function MdcRippleModule() {
        }
        MdcRippleModule.decorators = [
            { type: i0.NgModule, args: [{
                        exports: [MdcRippleDirective],
                        declarations: [MdcRippleDirective]
                    },] }
        ];
        return MdcRippleModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    /** Change event that is fired whenever the selected state of an option changes. */
    var MdcListSelectionChange = /** @class */ (function () {
        function MdcListSelectionChange(source) {
            this.source = source;
        }
        return MdcListSelectionChange;
    }());
    /**
     * Injection token used to provide the parent MdcList component to MdcListItem.
     */
    var MDC_LIST_PARENT_COMPONENT = new i0.InjectionToken('MDC_LIST_PARENT_COMPONENT');
    var uniqueIdCounter = 0;
    var MdcListItemGraphic = /** @class */ (function () {
        function MdcListItemGraphic(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListItemGraphic.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcListItemGraphic], mdc-list-item-graphic',
                        exportAs: 'mdcListItemGraphic',
                        host: {
                            'role': 'presentation',
                            'class': 'mdc-list-item__graphic',
                            '[attr.aria-hidden]': 'true'
                        }
                    },] }
        ];
        /** @nocollapse */
        MdcListItemGraphic.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        return MdcListItemGraphic;
    }());
    var MdcListItemMeta = /** @class */ (function () {
        function MdcListItemMeta(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListItemMeta.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcListItemMeta], mdc-list-item-meta',
                        exportAs: 'mdcListItemMeta',
                        host: { 'class': 'mdc-list-item__meta' }
                    },] }
        ];
        /** @nocollapse */
        MdcListItemMeta.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        return MdcListItemMeta;
    }());
    var MdcListItemText = /** @class */ (function () {
        function MdcListItemText(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListItemText.decorators = [
            { type: i0.Component, args: [{
                        selector: '[mdcListItemText], mdc-list-item-text',
                        exportAs: 'mdcListItemText',
                        host: { 'class': 'mdc-list-item__text' },
                        template: "\n  <ng-container>\n    <span class=\"mdc-list-item__primary-text\"><ng-content></ng-content></span>\n    <span class=\"mdc-list-item__secondary-text\" *ngIf=\"secondaryText\">{{secondaryText}}</span>\n  </ng-container>",
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcListItemText.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        MdcListItemText.propDecorators = {
            secondaryText: [{ type: i0.Input }]
        };
        return MdcListItemText;
    }());
    var MdcListItemSecondary = /** @class */ (function () {
        function MdcListItemSecondary(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListItemSecondary.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcListItemSecondary], mdc-list-item-secondary',
                        exportAs: 'mdcListItemSecondary',
                        host: { 'class': 'mdc-list-item__secondary-text' }
                    },] }
        ];
        /** @nocollapse */
        MdcListItemSecondary.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        return MdcListItemSecondary;
    }());
    var MdcListItem = /** @class */ (function () {
        function MdcListItem(ripple, _changeDetectorRef, elementRef, _parent) {
            this.ripple = ripple;
            this._changeDetectorRef = _changeDetectorRef;
            this.elementRef = elementRef;
            this._parent = _parent;
            this._id = "mdc-list-item-" + uniqueIdCounter++;
            this.tabIndex = -1;
            this._selected = false;
            this._activated = false;
            this._disabled = false;
            this.selectionChange = new i0.EventEmitter();
            this._root = this.elementRef.nativeElement;
            this.ripple = this._createRipple();
            this.ripple.init();
        }
        Object.defineProperty(MdcListItem.prototype, "id", {
            /** The unique ID of the list item. */
            get: function () {
                return this._id;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcListItem.prototype, "selected", {
            /** Whether the list item is selected. */
            get: function () {
                return this._selected;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._selected) {
                    this._selected = newValue;
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcListItem.prototype, "activated", {
            /** Whether the list item is activated. */
            get: function () {
                return this._activated;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._activated) {
                    this._activated = newValue;
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcListItem.prototype, "disabled", {
            /** Whether the list item is disabled. */
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._disabled) {
                    this._disabled = newValue;
                    this._changeDetectorRef.markForCheck();
                }
            },
            enumerable: true,
            configurable: true
        });
        MdcListItem.prototype.ngOnDestroy = function () {
            this.ripple.destroy();
        };
        MdcListItem.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, MdcRipple.createAdapter(this)), { isSurfaceDisabled: function () { return _this._disabled || _this._parent.disableRipple; } });
            return new MdcRipple(this.elementRef, new ripple.MDCRippleFoundation(adapter));
        };
        MdcListItem.prototype.focus = function () {
            this.getListItemElement().focus();
        };
        MdcListItem.prototype.setRole = function (role) {
            this.getListItemElement().setAttribute('role', role);
        };
        MdcListItem.prototype.getListItemElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcListItem.prototype._onKeydown = function (evt) {
            if (evt.keyCode === keycodes.ENTER || evt.keyCode === keycodes.SPACE) {
                this._emitChangeEvent();
            }
        };
        /** Emits a change event if the selected state of an option changed. */
        MdcListItem.prototype._emitChangeEvent = function () {
            if (this._disabled) {
                return;
            }
            this.selectionChange.emit(new MdcListSelectionChange(this));
        };
        MdcListItem.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-list-item, a[mdc-list-item]',
                        exportAs: 'mdcListItem',
                        host: {
                            'role': 'listitem',
                            '[id]': 'id',
                            '[tabIndex]': 'tabIndex',
                            'class': 'mdc-list-item',
                            '[attr.data-value]': 'value',
                            '[class.mdc-list-item--selected]': 'selected',
                            '[class.mdc-list-item--activated]': 'activated',
                            '[class.mdc-list-item--disabled]': 'disabled',
                            '(click)': '_emitChangeEvent()',
                            '(keydown)': '_onKeydown($event)'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush,
                        providers: [MdcRipple]
                    }] }
        ];
        /** @nocollapse */
        MdcListItem.ctorParameters = function () { return [
            { type: MdcRipple },
            { type: i0.ChangeDetectorRef },
            { type: i0.ElementRef },
            { type: undefined, decorators: [{ type: i0.Optional }, { type: i0.Inject, args: [MDC_LIST_PARENT_COMPONENT,] }] }
        ]; };
        MdcListItem.propDecorators = {
            value: [{ type: i0.Input }],
            tabIndex: [{ type: i0.Input }],
            selected: [{ type: i0.Input }],
            activated: [{ type: i0.Input }],
            disabled: [{ type: i0.Input }],
            selectionChange: [{ type: i0.Output }]
        };
        return MdcListItem;
    }());

    /** Change event that is being fired whenever the selected state of an option changes. */
    var MdcListItemChange = /** @class */ (function () {
        function MdcListItemChange(
        /** Reference to the selection list that emitted the event. */
        source, 
        /** Reference to the option that has been changed. */
        option) {
            this.source = source;
            this.option = option;
        }
        return MdcListItemChange;
    }());
    var MdcListGroup = /** @class */ (function () {
        function MdcListGroup(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListGroup.decorators = [
            { type: i0.Component, args: [{
                        selector: '[mdcListGroup], mdc-list-group',
                        exportAs: 'mdcListGroup',
                        host: { 'class': 'mdc-list-group' },
                        template: "\n  <h3 class=\"mdc-list-group__subheader\" *ngIf=\"subheader\">{{subheader}}</h3>\n  <ng-content></ng-content>",
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcListGroup.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        MdcListGroup.propDecorators = {
            subheader: [{ type: i0.Input }]
        };
        return MdcListGroup;
    }());
    var MdcListGroupSubheader = /** @class */ (function () {
        function MdcListGroupSubheader(elementRef) {
            this.elementRef = elementRef;
        }
        MdcListGroupSubheader.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcListGroupSubheader], mdc-list-group-subheader',
                        exportAs: 'mdcListGroupSubheader',
                        host: { 'class': 'mdc-list-group__subheader' }
                    },] }
        ];
        /** @nocollapse */
        MdcListGroupSubheader.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        return MdcListGroupSubheader;
    }());
    var MdcList = /** @class */ (function (_super) {
        __extends(MdcList, _super);
        function MdcList(_platform, _changeDetectorRef, elementRef) {
            var _this = _super.call(this, elementRef) || this;
            _this._platform = _platform;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            _this._twoLine = false;
            _this._dense = false;
            _this._border = false;
            _this._avatar = false;
            _this._interactive = true;
            _this._disableRipple = false;
            _this._useActivatedClass = false;
            _this._useSelectedClass = false;
            _this._verticalOrientation = true;
            _this._wrapFocus = false;
            /** Emits a change event whenever the selected state of an option changes. */
            _this.selectionChange = new i0.EventEmitter();
            /** Emits an event for keyboard and mouse actions. */
            _this.actionEvent = new i0.EventEmitter();
            /** Subscription to changes in list items. */
            _this._changeSubscription = null;
            /** Subscription to selection events in list items. */
            _this.itemSelectionSubscription = null;
            return _this;
        }
        Object.defineProperty(MdcList.prototype, "twoLine", {
            get: function () {
                return this._twoLine;
            },
            set: function (value) {
                this._twoLine = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "dense", {
            get: function () {
                return this._dense;
            },
            set: function (value) {
                this._dense = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "border", {
            get: function () {
                return this._border;
            },
            set: function (value) {
                this._border = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "avatar", {
            get: function () {
                return this._avatar;
            },
            set: function (value) {
                this._avatar = coercion.coerceBooleanProperty(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "interactive", {
            get: function () {
                return this._interactive;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._interactive) {
                    this._interactive = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "disableRipple", {
            get: function () {
                return this._disableRipple;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._disableRipple) {
                    this._disableRipple = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "singleSelection", {
            get: function () {
                return this._singleSelection;
            },
            set: function (value) {
                if (value !== undefined) {
                    var newValue = coercion.coerceBooleanProperty(value);
                    if (newValue !== this._singleSelection) {
                        this._singleSelection = newValue;
                        this._foundation.setSingleSelection(this._singleSelection);
                        this._changeDetectorRef.markForCheck();
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "useActivatedClass", {
            get: function () {
                return this._useActivatedClass;
            },
            set: function (value) {
                this._useActivatedClass = coercion.coerceBooleanProperty(value);
                this._foundation.setUseActivatedClass(this._useActivatedClass);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "useSelectedClass", {
            get: function () {
                return this._useSelectedClass;
            },
            set: function (value) {
                this._useSelectedClass = coercion.coerceBooleanProperty(value);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "verticalOrientation", {
            get: function () {
                return this._verticalOrientation;
            },
            set: function (value) {
                this._verticalOrientation = coercion.coerceBooleanProperty(value);
                this._foundation.setVerticalOrientation(this._verticalOrientation);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "wrapFocus", {
            get: function () {
                return this._wrapFocus;
            },
            set: function (value) {
                this._wrapFocus = coercion.coerceBooleanProperty(value);
                this._foundation.setWrapFocus(this._wrapFocus);
                this._changeDetectorRef.markForCheck();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcList.prototype, "listItemSelections", {
            /** Combined stream of all of the list item selection events. */
            get: function () {
                return rxjs.merge.apply(void 0, __spread(this.items.map(function (item) { return item.selectionChange; })));
            },
            enumerable: true,
            configurable: true
        });
        MdcList.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                getListItemCount: function () { return _this.items.length; },
                getFocusedElementIndex: function () {
                    if (!_this._platform.isBrowser && document.activeElement) {
                        return -1;
                    }
                    return _this.items.toArray().findIndex(function (_) { return _.getListItemElement() === document.activeElement; }) || -1;
                },
                setAttributeForElementIndex: function (index, attr, value) {
                    var _a;
                    var item = _this.getListItemByIndex(index);
                    (_a = item === null || item === void 0 ? void 0 : item.getListItemElement()) === null || _a === void 0 ? void 0 : _a.setAttribute(attr, value);
                },
                addClassForElementIndex: function (index, className) {
                    return _this.items.toArray()[index].getListItemElement().classList.add(className);
                },
                removeClassForElementIndex: function (index, className) {
                    var _a, _b;
                    var item = _this.getListItemByIndex(index);
                    (_b = (_a = item === null || item === void 0 ? void 0 : item.getListItemElement()) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.remove(className);
                },
                getAttributeForElementIndex: function (index, attr) {
                    return _this.items.toArray()[index].getListItemElement().getAttribute(attr);
                },
                focusItemAtIndex: function (index) { return _this.focusItemAtIndex(index); },
                setTabIndexForListItemChildren: function (listItemIndex, tabIndexValue) {
                    var listItemChildren = [].slice.call(_this.items.toArray()[listItemIndex].getListItemElement()
                        .querySelectorAll(list.strings.CHILD_ELEMENTS_TO_TOGGLE_TABINDEX));
                    listItemChildren.forEach(function (ele) { return ele.setAttribute('tabindex', "" + tabIndexValue); });
                },
                hasCheckboxAtIndex: function (index) {
                    var listItem = _this.items.toArray()[index].getListItemElement();
                    return !!listItem.querySelector(list.strings.CHECKBOX_SELECTOR);
                },
                hasRadioAtIndex: function (index) {
                    var listItem = _this.items.toArray()[index].getListItemElement();
                    return !!listItem.querySelector(list.strings.RADIO_SELECTOR);
                },
                isCheckboxCheckedAtIndex: function (index) {
                    var listItem = _this.items.toArray()[index].getListItemElement();
                    var toggleEl = listItem.querySelector(list.strings.CHECKBOX_SELECTOR);
                    return toggleEl.checked;
                },
                setCheckedCheckboxOrRadioAtIndex: function (index, isChecked) {
                    var listItem = _this.items.toArray()[index].getListItemElement();
                    var toggleEl = listItem.querySelector(list.strings.CHECKBOX_RADIO_SELECTOR);
                    toggleEl.checked = isChecked;
                    if (_this._platform.isBrowser) {
                        var event_1 = document.createEvent('Event');
                        event_1.initEvent('change', true, true);
                        toggleEl.dispatchEvent(event_1);
                    }
                },
                isFocusInsideList: function () { return _this._platform.isBrowser ?
                    _this.elementRef.nativeElement.contains(document.activeElement) : false; },
                isRootFocused: function () { return _this._platform.isBrowser ? document.activeElement === _this._getHostElement() : false; },
                listItemAtIndexHasClass: function (index, className) {
                    return _this.items.toArray()[index].getListItemElement().classList.contains(className);
                },
                notifyAction: function (index) { return _this.actionEvent.emit({ index: index }); }
            };
            return new list.MDCListFoundation(adapter);
        };
        MdcList.prototype.ngAfterViewInit = function () {
            var _this = this;
            this._foundation.init();
            this._foundation.layout();
            // When list items change, re-subscribe
            this._changeSubscription = this.items.changes.pipe(operators.startWith(null))
                .subscribe(function () {
                if (_this.items.length) {
                    _this._resetListItems();
                }
            });
        };
        MdcList.prototype.ngOnDestroy = function () {
            var _a;
            this._dropSubscriptions();
            (_a = this._changeSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
            this._foundation.destroy();
        };
        MdcList.prototype.setSelectedIndex = function (index) {
            this.reset();
            this._foundation.setSelectedIndex(index);
            if (index === -1) {
                return;
            }
            var selectedItem = this.items.toArray()[index];
            if (selectedItem) {
                this._applySelectionState(selectedItem);
            }
        };
        MdcList.prototype.setSelectedValue = function (value) {
            this.reset();
            if (value === null) {
                return;
            }
            var selectedItem = this.getListItemByValue(value);
            this._foundation.setSelectedIndex(this.getListItemIndexByValue(value));
            if (selectedItem) {
                this._applySelectionState(selectedItem);
            }
        };
        MdcList.prototype.getSelectedItem = function () {
            return this.items.toArray().find(function (_) { return _.selected || _.activated; });
        };
        MdcList.prototype.getSelectedIndex = function () {
            return this.items.toArray().findIndex(function (_) { return _.selected || _.activated; });
        };
        MdcList.prototype.getSelectedValue = function () {
            var item = this.items ? this.items.find(function (_) { return _.selected; }) : null;
            return item && item.value ? item.value : null;
        };
        MdcList.prototype.getSelectedText = function () {
            var selectedItem = this.getSelectedItem();
            return selectedItem && selectedItem.getListItemElement().textContent || '';
        };
        MdcList.prototype.getListItemByValue = function (value) {
            return this.items.toArray().find(function (_) { return _.value === value; });
        };
        MdcList.prototype.getListItemByIndex = function (index) {
            return this.items.toArray()[index];
        };
        MdcList.prototype.getListItemIndexByValue = function (value) {
            return this.items.toArray().findIndex(function (_) { return _.value === value; });
        };
        MdcList.prototype.focusItemAtIndex = function (index) {
            this.items.toArray()[index].getListItemElement().focus();
        };
        MdcList.prototype.focusFirstElement = function () {
            return this._foundation.focusFirstElement();
        };
        MdcList.prototype.focusLastElement = function () {
            return this._foundation.focusLastElement();
        };
        MdcList.prototype.focusNextElement = function (index) {
            return this._foundation.focusNextElement(index);
        };
        MdcList.prototype.focusPrevElement = function (index) {
            return this._foundation.focusPrevElement(index);
        };
        MdcList.prototype.setRole = function (role) {
            this._getHostElement().setAttribute('role', role);
        };
        MdcList.prototype.setTabIndex = function (index) {
            this._getHostElement().tabIndex = index;
        };
        MdcList.prototype.focus = function () {
            this._getHostElement().focus();
        };
        MdcList.prototype.reset = function () {
            this.items.forEach(function (_) {
                _.selected = false;
                _.activated = false;
            });
        };
        MdcList.prototype._applySelectionState = function (item) {
            if (this.useActivatedClass) {
                item.activated = true;
            }
            else if (this.useSelectedClass) {
                item.selected = true;
            }
        };
        MdcList.prototype._resetListItems = function () {
            this._dropSubscriptions();
            this._listenForListItemSelection();
        };
        MdcList.prototype._dropSubscriptions = function () {
            if (this.itemSelectionSubscription) {
                this.itemSelectionSubscription.unsubscribe();
                this.itemSelectionSubscription = null;
            }
        };
        /** Listens to selected events on each list item. */
        MdcList.prototype._listenForListItemSelection = function () {
            var _this = this;
            this.itemSelectionSubscription = this.listItemSelections.subscribe(function (event) {
                if (_this.singleSelection) {
                    _this.items.filter(function (_) { return _.id !== event.source.id && (_.activated || _.selected); })
                        .forEach(function (_) {
                        _.selected = false;
                        _.activated = false;
                    });
                }
                _this._applySelectionState(event.source);
                if (!_this.singleSelection) {
                    event.source.ripple.handleBlur();
                }
                _this.selectionChange.emit(new MdcListItemChange(_this, event.source));
            });
        };
        MdcList.prototype._onFocusIn = function (evt) {
            var index = this._getListItemIndexByEvent(evt);
            this._foundation.handleFocusIn(evt, index);
        };
        MdcList.prototype._onFocusOut = function (evt) {
            var index = this._getListItemIndexByEvent(evt);
            if (index >= 0) {
                this._foundation.handleFocusOut(evt, index);
            }
        };
        MdcList.prototype._onKeydown = function (evt) {
            var index = this._getListItemIndexByEvent(evt);
            var target = evt.target;
            if (index >= 0) {
                this._foundation.handleKeydown(evt, target.classList.contains(list.cssClasses.LIST_ITEM_CLASS), index);
            }
        };
        MdcList.prototype._handleClickEvent = function (evt) {
            var index = this._getListItemIndexByEvent(evt);
            var target = evt.target;
            var listItem = this._getListItemByEventTarget(evt.target);
            if (listItem && listItem.disabled) {
                return;
            }
            // Toggle the checkbox only if it's not the target of the event, or the checkbox will have 2 change events.
            var toggleCheckbox = !matches(target, list.strings.CHECKBOX_RADIO_SELECTOR);
            this._foundation.handleClick(index, toggleCheckbox);
        };
        MdcList.prototype._getListItemByEventTarget = function (target) {
            return this.items.toArray().find(function (_) { return _.getListItemElement() === target; });
        };
        MdcList.prototype._getListItemIndexByEvent = function (evt) {
            return this.items.toArray().findIndex(function (_) { return _.getListItemElement() === evt.target; });
        };
        /** Retrieves the DOM element of the component host. */
        MdcList.prototype._getHostElement = function () {
            return this.elementRef.nativeElement;
        };
        MdcList.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-list',
                        exportAs: 'mdcList',
                        host: {
                            'role': 'list',
                            'class': 'mdc-list',
                            '[attr.aria-orientation]': 'verticalOrientation ? "vertical" : "horizontal"',
                            '[class.mdc-list--dense]': 'dense',
                            '[class.mdc-list--avatar-list]': 'avatar',
                            '[class.ngx-mdc-list--border]': 'border',
                            '[class.mdc-list--non-interactive]': '!interactive',
                            '[class.mdc-list--two-line]': 'twoLine',
                            '(click)': '_handleClickEvent($event)',
                            '(keydown)': '_onKeydown($event)',
                            '(focusin)': '_onFocusIn($event)',
                            '(focusout)': '_onFocusOut($event)'
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush,
                        providers: [{ provide: MDC_LIST_PARENT_COMPONENT, useExisting: MdcList }]
                    }] }
        ];
        /** @nocollapse */
        MdcList.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: i0.ChangeDetectorRef },
            { type: i0.ElementRef }
        ]; };
        MdcList.propDecorators = {
            twoLine: [{ type: i0.Input }],
            dense: [{ type: i0.Input }],
            border: [{ type: i0.Input }],
            avatar: [{ type: i0.Input }],
            interactive: [{ type: i0.Input }],
            disableRipple: [{ type: i0.Input }],
            singleSelection: [{ type: i0.Input }],
            useActivatedClass: [{ type: i0.Input }],
            useSelectedClass: [{ type: i0.Input }],
            verticalOrientation: [{ type: i0.Input }],
            wrapFocus: [{ type: i0.Input }],
            items: [{ type: i0.ContentChildren, args: [MdcListItem, { descendants: true },] }],
            selectionChange: [{ type: i0.Output }],
            actionEvent: [{ type: i0.Output }]
        };
        return MdcList;
    }(MDCComponent));

    var LIST_DECLARATIONS = [
        MdcList,
        MdcListDivider,
        MdcListGroup,
        MdcListGroupSubheader,
        MdcListItem,
        MdcListItemGraphic,
        MdcListItemMeta,
        MdcListItemSecondary,
        MdcListItemText
    ];
    var MdcListModule = /** @class */ (function () {
        function MdcListModule() {
        }
        MdcListModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [common.CommonModule],
                        exports: LIST_DECLARATIONS,
                        declarations: LIST_DECLARATIONS,
                    },] }
        ];
        return MdcListModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcMenuSelectedEvent = /** @class */ (function () {
        function MdcMenuSelectedEvent(index, source) {
            this.index = index;
            this.source = source;
        }
        return MdcMenuSelectedEvent;
    }());
    var nextUniqueId = 0;
    var MdcMenu = /** @class */ (function (_super) {
        __extends(MdcMenu, _super);
        function MdcMenu() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /** Emits whenever the component is destroyed. */
            _this._destroyed = new rxjs.Subject();
            _this._uniqueId = menu.cssClasses.ROOT + "-" + ++nextUniqueId;
            _this.id = _this._uniqueId;
            _this._wrapFocus = false;
            _this._closeSurfaceOnSelection = true;
            _this.selected = new i0.EventEmitter();
            _this._menuFoundation = new menu.MDCMenuFoundation(_this._createAdapter());
            return _this;
        }
        Object.defineProperty(MdcMenu.prototype, "wrapFocus", {
            get: function () {
                return this._wrapFocus;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._wrapFocus) {
                    this._wrapFocus = newValue;
                    this._list.wrapFocus = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenu.prototype, "closeSurfaceOnSelection", {
            get: function () {
                return this._closeSurfaceOnSelection;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._closeSurfaceOnSelection) {
                    this._closeSurfaceOnSelection = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenu.prototype, "defaultFocusState", {
            get: function () {
                return this._defaultFocusState;
            },
            set: function (value) {
                if (value !== this._defaultFocusState) {
                    this._defaultFocusState = coercion.coerceNumberProperty(value, 0);
                    this._menuFoundation.setDefaultFocusState(this._defaultFocusState);
                }
            },
            enumerable: true,
            configurable: true
        });
        MdcMenu.prototype._createAdapter = function () {
            var _this = this;
            return Object.assign({
                addClassToElementAtIndex: function (index, className) {
                    return _this._list.items.toArray()[index].getListItemElement().classList.add(className);
                },
                removeClassFromElementAtIndex: function (index, className) {
                    return _this._list.items.toArray()[index].getListItemElement().classList.remove(className);
                },
                addAttributeToElementAtIndex: function (index, attr, value) {
                    return _this._list.items.toArray()[index].getListItemElement().setAttribute(attr, value);
                },
                removeAttributeFromElementAtIndex: function (index, attr) {
                    return _this._list.items.toArray()[index].getListItemElement().removeAttribute(attr);
                },
                elementContainsClass: function (element, className) { return element.classList.contains(className); },
                closeSurface: function (skipRestoreFocus) {
                    if (_this.closeSurfaceOnSelection) {
                        _this._foundation.close(skipRestoreFocus);
                    }
                },
                getElementIndex: function (element) {
                    return _this._list.items.toArray().findIndex(function (_) { return _.getListItemElement() === element; });
                },
                notifySelected: function (evtData) {
                    return _this.selected.emit(new MdcMenuSelectedEvent(evtData.index, _this._list.items.toArray()[evtData.index]));
                },
                getMenuItemCount: function () { return _this._list.items.toArray().length; },
                focusItemAtIndex: function (index) { return _this._list.items.toArray()[index].focus(); },
                focusListRoot: function () { return _this._list.focus(); },
                isSelectableItemAtIndex: function (index) {
                    return !!closest(_this._list.items.toArray()[index].getListItemElement(), "." + menu.cssClasses.MENU_SELECTION_GROUP);
                },
                getSelectedSiblingOfItemAtIndex: function (index) {
                    var selectionGroupEl = closest(_this._list.items.toArray()[index].getListItemElement(), "." + menu.cssClasses.MENU_SELECTION_GROUP);
                    var selectedItemEl = selectionGroupEl.querySelector("." + menu.cssClasses.MENU_SELECTED_LIST_ITEM);
                    return selectedItemEl ? _this._list.items.toArray().findIndex(function (_) {
                        return _.elementRef.nativeElement === selectedItemEl;
                    }) : -1;
                }
            });
        };
        MdcMenu.prototype.ngAfterContentInit = function () {
            var _this = this;
            this.initMenuSurface();
            this._initList();
            this.opened.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function () { return _this._menuFoundation.handleMenuSurfaceOpened(); });
        };
        MdcMenu.prototype.ngOnDestroy = function () {
            this._destroyed.next();
            this._destroyed.complete();
            this.destroyMenuSurface();
            this._menuFoundation.destroy();
        };
        MdcMenu.prototype._handleKeydown = function (evt) {
            this._menuFoundation.handleKeydown(evt);
        };
        MdcMenu.prototype._initList = function () {
            var _this = this;
            if (!this._list) {
                return;
            }
            this._list.setRole('menu');
            this._list.wrapFocus = this._wrapFocus;
            this._list.setTabIndex(-1);
            // When the list items change, re-subscribe
            this._list.items.changes.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function () { return _this._list.items.forEach(function (item) { return item.setRole('menuitem'); }); });
            this._list.actionEvent.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function (event) {
                return _this._menuFoundation.handleItemAction(_this._list.items.toArray()[event.index].getListItemElement());
            });
        };
        MdcMenu.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-menu',
                        exportAs: 'mdcMenu',
                        host: {
                            '[id]': 'id',
                            'class': 'mdc-menu mdc-menu-surface',
                            '(keydown)': '_handleKeydown($event)',
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        MdcMenu.propDecorators = {
            id: [{ type: i0.Input }],
            wrapFocus: [{ type: i0.Input }],
            closeSurfaceOnSelection: [{ type: i0.Input }],
            defaultFocusState: [{ type: i0.Input }],
            selected: [{ type: i0.Output }],
            _list: [{ type: i0.ContentChild, args: [MdcList, { static: false },] }]
        };
        return MdcMenu;
    }(MdcMenuSurfaceBase));

    var MdcMenuSelectionGroup = /** @class */ (function () {
        function MdcMenuSelectionGroup(elementRef) {
            this.elementRef = elementRef;
        }
        MdcMenuSelectionGroup.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcMenuSelectionGroup], mdc-menu-selection-group',
                        host: { 'class': 'mdc-menu__selection-group' },
                        exportAs: 'mdcMenuSelectionGroup'
                    },] }
        ];
        /** @nocollapse */
        MdcMenuSelectionGroup.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        return MdcMenuSelectionGroup;
    }());
    var MdcMenuSelectionGroupIcon = /** @class */ (function () {
        function MdcMenuSelectionGroupIcon(elementRef) {
            this.elementRef = elementRef;
        }
        MdcMenuSelectionGroupIcon.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcMenuSelectionGroupIcon], mdc-menu-selection-group-icon',
                        host: { 'class': 'mdc-menu__selection-group-icon' },
                        exportAs: 'mdcMenuSelectionGroupIcon'
                    },] }
        ];
        /** @nocollapse */
        MdcMenuSelectionGroupIcon.ctorParameters = function () { return [
            { type: i0.ElementRef }
        ]; };
        return MdcMenuSelectionGroupIcon;
    }());

    var MENU_DECLARATIONS = [
        MdcMenu,
        MdcMenuSelectionGroup,
        MdcMenuSelectionGroupIcon
    ];
    var MdcMenuModule = /** @class */ (function () {
        function MdcMenuModule() {
        }
        MdcMenuModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [MdcMenuSurfaceModule],
                        exports: __spread(MENU_DECLARATIONS, [
                            MdcMenuSurfaceModule
                        ]),
                        declarations: [MENU_DECLARATIONS]
                    },] }
        ];
        return MdcMenuModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    var MdcSelectIcon = /** @class */ (function () {
        function MdcSelectIcon() {
        }
        MdcSelectIcon.decorators = [
            { type: i0.Directive, args: [{
                        selector: '[mdcSelectIcon]',
                        exportAs: 'mdcSelectIcon',
                        host: { 'class': 'mdc-select__icon' }
                    },] }
        ];
        return MdcSelectIcon;
    }());

    var MdcSelectHelperTextFoundation = /** @class */ (function (_super) {
        __extends(MdcSelectHelperTextFoundation, _super);
        function MdcSelectHelperTextFoundation(_hostElement, _document) {
            var _this = _super.call(this, _hostElement) || this;
            _this._hostElement = _hostElement;
            _this._document = _document;
            _this._initialized = false;
            return _this;
        }
        Object.defineProperty(MdcSelectHelperTextFoundation.prototype, "foundation", {
            get: function () {
                return this._foundation;
            },
            enumerable: true,
            configurable: true
        });
        MdcSelectHelperTextFoundation.prototype.getDefaultFoundation = function () {
            var _this = this;
            var adapter = {
                addClass: function (className) { return _this._helperLineElement.classList.add(className); },
                removeClass: function (className) { return _this._helperLineElement.classList.remove(className); },
                hasClass: function (className) { return _this._helperLineElement.classList.contains(className); },
                setAttr: function (attr, value) { return _this._helperLineElement.setAttribute(attr, value); },
                removeAttr: function (attr) { return _this._helperLineElement.removeAttribute(attr); },
                setContent: function (content) { return _this._helperLineElement.textContent = content; },
            };
            return new select.MDCSelectHelperTextFoundation(adapter);
        };
        /** Sets the persistency of the helper text. */
        MdcSelectHelperTextFoundation.prototype.setPersistent = function (isPersistent) {
            this._foundation.setPersistent(isPersistent);
        };
        /** True to make the helper text act as an error validation message. */
        MdcSelectHelperTextFoundation.prototype.setValidation = function (isValidation) {
            this._foundation.setValidation(isValidation);
        };
        /** Sets the validity of the helper text based on inputIsValid. */
        MdcSelectHelperTextFoundation.prototype.setValidity = function (inputIsValid) {
            this._foundation.setValidity(inputIsValid);
        };
        /** Makes the helper text visible to the screen reader. */
        MdcSelectHelperTextFoundation.prototype.showToScreenReader = function () {
            this._foundation.showToScreenReader();
        };
        /** Sets the content of the helper text. */
        MdcSelectHelperTextFoundation.prototype.setContent = function (content) {
            this._foundation.setContent(content);
        };
        /** Initializes the foundation. */
        MdcSelectHelperTextFoundation.prototype.init = function () {
            if (this._initialized) {
                return;
            }
            this._createHelperElement();
            this._foundation.init();
            this._initialized = true;
        };
        /** Destroys the foundation. */
        MdcSelectHelperTextFoundation.prototype.destroy = function () {
            var _a, _b;
            (_b = (_a = this._helperLineElement) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(this._helperLineElement);
            this._hostElement = this._helperLineElement = null;
            this._foundation.destroy();
            this._initialized = false;
        };
        /** Creates and appends the helper element. */
        MdcSelectHelperTextFoundation.prototype._createHelperElement = function () {
            this._helperLineElement = this._document.createElement('p');
            this._helperLineElement.className = 'mdc-select-helper-text';
            this._appendHelperElement();
        };
        /**
         * Appends the helper element to the select.
         */
        MdcSelectHelperTextFoundation.prototype._appendHelperElement = function () {
            if (!this._helperLineElement) {
                throw Error('Helper element has not been created and cannot be appended');
            }
            this._hostElement.nativeElement.insertAdjacentElement('afterend', this._helperLineElement);
        };
        MdcSelectHelperTextFoundation.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        return MdcSelectHelperTextFoundation;
    }(MDCComponent));

    /**
     * Injection token that can be used to configure the default options for all
     * mdc-select usage within an app.
     */
    var MDC_SELECT_DEFAULT_OPTIONS = new i0.InjectionToken('MDC_SELECT_DEFAULT_OPTIONS');
    var MdcSelectBase = /** @class */ (function (_super) {
        __extends(MdcSelectBase, _super);
        function MdcSelectBase(_elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) {
            var _this = _super.call(this, _elementRef) || this;
            _this._elementRef = _elementRef;
            _this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
            _this._parentForm = _parentForm;
            _this._parentFormGroup = _parentFormGroup;
            _this.ngControl = ngControl;
            return _this;
        }
        return MdcSelectBase;
    }(MDCComponent));
    var _MdcSelectMixinBase = mixinErrorState(MdcSelectBase);
    var MdcSelectChange = /** @class */ (function () {
        function MdcSelectChange(source, index, value) {
            this.source = source;
            this.index = index;
            this.value = value;
        }
        return MdcSelectChange;
    }());
    var nextUniqueId$1 = 0;
    var MdcSelect = /** @class */ (function (_super) {
        __extends(MdcSelect, _super);
        function MdcSelect(_platform, _changeDetectorRef, elementRef, _defaultErrorStateMatcher, _document, _parentFormField, _ripple, ngControl, _parentForm, _parentFormGroup, _defaults) {
            var _this = _super.call(this, elementRef, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
            _this._platform = _platform;
            _this._changeDetectorRef = _changeDetectorRef;
            _this.elementRef = elementRef;
            _this._defaultErrorStateMatcher = _defaultErrorStateMatcher;
            _this._document = _document;
            _this._parentFormField = _parentFormField;
            _this._ripple = _ripple;
            _this.ngControl = ngControl;
            _this._defaults = _defaults;
            /** Emits whenever the component is destroyed. */
            _this._destroyed = new rxjs.Subject();
            _this._uniqueId = "mdc-select-" + ++nextUniqueId$1;
            _this._initialized = false;
            _this._selectedText = '';
            _this.id = _this._uniqueId;
            _this._disabled = false;
            _this._outlined = false;
            _this._required = false;
            _this.compareWith = function (a1, a2) { return a1 === a2; };
            _this._helperPersistent = false;
            /** Event emitted when the selected value has been changed by the user. */
            _this.selectionChange = new i0.EventEmitter();
            /**
             * Event that emits whenever the raw value of the select changes. This is here primarily
             * to facilitate the two-way binding for the `value` input.
             */
            _this.valueChange = new i0.EventEmitter();
            _this.blur = new i0.EventEmitter();
            _this._onFocus = new i0.EventEmitter();
            /** View to model callback called when value changes */
            _this._onChange = function () { };
            /** View to model callback called when select has been touched */
            _this._onTouched = function () { };
            _this._root = _this.elementRef.nativeElement;
            if (_this.ngControl) {
                // Note: we provide the value accessor through here, instead of
                // the `providers` to avoid running into a circular import.
                _this.ngControl.valueAccessor = _this;
            }
            if (_this._parentFormField) {
                _parentFormField.elementRef.nativeElement.classList.add('ngx-form-field-select');
            }
            // Force setter to be called in case id was not specified.
            _this.id = _this.id;
            _this._setDefaultGlobalOptions();
            return _this;
        }
        Object.defineProperty(MdcSelect.prototype, "disabled", {
            get: function () {
                return this._disabled;
            },
            set: function (value) {
                this.setDisabledState(value);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSelect.prototype, "outlined", {
            get: function () {
                return this._outlined;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                this._outlined = newValue;
                this.layout();
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSelect.prototype, "required", {
            get: function () {
                return this._required;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._required) {
                    this._required = newValue;
                    if (this._initialized && !this._required) {
                        this.valid = true;
                        this._syncHelperValidityState();
                        this._changeDetectorRef.markForCheck();
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSelect.prototype, "valid", {
            get: function () {
                return this._valid;
            },
            set: function (value) {
                var _a;
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._valid) {
                    this._valid = newValue;
                    (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.setValid(newValue);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSelect.prototype, "value", {
            /** Value of the select */
            get: function () {
                return this._value;
            },
            set: function (newValue) {
                if (newValue !== this._value) {
                    this.setSelectionByValue(newValue);
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSelect.prototype, "helperPersistent", {
            get: function () {
                return this._helperPersistent;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._helperPersistent) {
                    this._helperPersistent = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcSelect.prototype, "_hasPlaceholder", {
            get: function () {
                return this.placeholder ? this.placeholder.length > 0 : false;
            },
            enumerable: true,
            configurable: true
        });
        MdcSelect.prototype.getDefaultFoundation = function () {
            // Do not initialize foundation until ngAfterViewInit runs
            if (!this._initialized) {
                return undefined;
            }
            var adapter = __assign(__assign(__assign(__assign({}, this._getSelectAdapterMethods()), this._getCommonAdapterMethods()), this._getOutlineAdapterMethods()), this._getLabelAdapterMethods());
            return new select.MDCSelectFoundation(adapter, this._getFoundationMap());
        };
        MdcSelect.prototype._getSelectAdapterMethods = function () {
            var _this = this;
            return {
                getSelectedMenuItem: function () {
                    return _this._menu.elementRef.nativeElement.querySelector(select.strings.SELECTED_ITEM_SELECTOR);
                },
                getMenuItemAttr: function (menuItem, attr) { return menuItem.getAttribute(attr); },
                setSelectedText: function (text) { return _this._selectedText = text; },
                isSelectAnchorFocused: function () { return _this._platform.isBrowser ?
                    document.activeElement === _this._selectAnchor.nativeElement : false; },
                getSelectAnchorAttr: function (attr) { return _this._selectAnchor.nativeElement.getAttribute(attr); },
                setSelectAnchorAttr: function (attr, value) { return _this._selectAnchor.nativeElement.setAttribute(attr, value); },
                openMenu: function () { return _this._menu.open = true; },
                closeMenu: function () { return _this._menu.open = false; },
                getAnchorElement: function () { return _this._selectAnchor.nativeElement; },
                setMenuAnchorElement: function (anchorEl) { return _this._menu.anchorElement = anchorEl; },
                setMenuAnchorCorner: function (anchorCorner) { return _this._menu.anchorCorner = anchorCorner; },
                setMenuWrapFocus: function (wrapFocus) { return _this._menu.wrapFocus = wrapFocus; },
                setAttributeAtIndex: function (index, attributeName, attributeValue) {
                    return _this._menu._list.items.toArray()[index].getListItemElement().setAttribute(attributeName, attributeValue);
                },
                removeAttributeAtIndex: function (index, attributeName) {
                    return _this._menu._list.items.toArray()[index].getListItemElement().removeAttribute(attributeName);
                },
                focusMenuItemAtIndex: function (index) { return _this._menu._list.items.toArray()[index].focus(); },
                getMenuItemCount: function () { return _this._menu._list.items.length; },
                getMenuItemValues: function () { var _a; return (_a = _this._menu._list.items.map(function (el) {
                    return el.getListItemElement().getAttribute(select.strings.VALUE_ATTR) || '';
                })) !== null && _a !== void 0 ? _a : []; },
                getMenuItemTextAtIndex: function (index) { var _a; return (_a = _this._menu._list.items.toArray()[index].getListItemElement().textContent) !== null && _a !== void 0 ? _a : ''; },
                addClassAtIndex: function (index, className) {
                    return _this._menu._list.items.toArray()[index].getListItemElement().classList.add(className);
                },
                removeClassAtIndex: function (index, className) {
                    return _this._menu._list.items.toArray()[index].getListItemElement().classList.remove(className);
                }
            };
        };
        MdcSelect.prototype._getCommonAdapterMethods = function () {
            var _this = this;
            return {
                addClass: function (className) { return _this._root.classList.add(className); },
                removeClass: function (className) { return _this._root.classList.remove(className); },
                hasClass: function (className) { return _this._root.classList.contains(className); },
                setRippleCenter: function (normalizedX) { var _a; return (_a = _this._lineRipple) === null || _a === void 0 ? void 0 : _a.setRippleCenter(normalizedX); },
                activateBottomLine: function () { var _a; return (_a = _this._lineRipple) === null || _a === void 0 ? void 0 : _a.activate(); },
                deactivateBottomLine: function () { var _a; return (_a = _this._lineRipple) === null || _a === void 0 ? void 0 : _a.deactivate(); },
                notifyChange: function () { }
            };
        };
        MdcSelect.prototype._getOutlineAdapterMethods = function () {
            var _this = this;
            return {
                hasOutline: function () { return !!_this._notchedOutline; },
                notchOutline: function (labelWidth) { var _a; return (_a = _this._notchedOutline) === null || _a === void 0 ? void 0 : _a.notch(labelWidth); },
                closeOutline: function () { var _a; return (_a = _this._notchedOutline) === null || _a === void 0 ? void 0 : _a.closeNotch(); }
            };
        };
        MdcSelect.prototype._getLabelAdapterMethods = function () {
            var _this = this;
            return {
                hasLabel: function () { return _this._hasPlaceholder; },
                floatLabel: function (shouldFloat) { var _a; return (_a = _this._getFloatingLabel()) === null || _a === void 0 ? void 0 : _a.float(shouldFloat); },
                getLabelWidth: function () { var _a, _b; return (_b = (_a = _this._getFloatingLabel()) === null || _a === void 0 ? void 0 : _a.getWidth()) !== null && _b !== void 0 ? _b : 0; }
            };
        };
        /** Returns a map of all subcomponents to subfoundations.*/
        MdcSelect.prototype._getFoundationMap = function () {
            var _a;
            return {
                helperText: (_a = this._foundationHelper) === null || _a === void 0 ? void 0 : _a.foundation
            };
        };
        MdcSelect.prototype.ngOnChanges = function (changes) {
            if (changes['helper'] || changes['helperPersistent'] || changes['validationMessage']) {
                this._syncHelper();
            }
        };
        MdcSelect.prototype.ngAfterViewInit = function () {
            var _this = this;
            this._initialized = true;
            this._asyncBuildFoundation()
                .then(function () {
                _this._selectBuilder();
            });
            this._initializeSelection();
            this._subscribeToMenuEvents();
        };
        MdcSelect.prototype.ngOnDestroy = function () {
            this.destroy();
        };
        /** Override MdcSelectBase destroy method */
        MdcSelect.prototype.destroy = function () {
            var _a;
            this._destroyed.next();
            this._destroyed.complete();
            (_a = this._lineRipple) === null || _a === void 0 ? void 0 : _a.destroy();
            this._ripple.destroy();
            this._foundation.destroy();
        };
        MdcSelect.prototype.ngDoCheck = function () {
            if (this.ngControl) {
                // We need to re-evaluate this on every change detection cycle, because there are some
                // error triggers that we can't subscribe to (e.g. parent form submissions). This means
                // that whatever logic is in here has to be super lean or we risk destroying the performance.
                this.updateErrorState();
            }
        };
        MdcSelect.prototype.writeValue = function (value) {
            if (this._initialized) {
                this.setSelectionByValue(value, false);
            }
        };
        MdcSelect.prototype.registerOnChange = function (fn) {
            this._onChange = fn;
        };
        MdcSelect.prototype.registerOnTouched = function (fn) {
            this._onTouched = fn;
        };
        MdcSelect.prototype.onFocus = function () {
            if (!this.disabled) {
                this._foundation.handleFocus();
                this._onFocus.emit(true);
            }
        };
        MdcSelect.prototype.onBlur = function () {
            this._foundation.handleBlur();
        };
        MdcSelect.prototype.onClick = function (evt) {
            this._foundation.handleClick(this._getNormalizedXCoordinate(evt));
        };
        MdcSelect.prototype.onKeydown = function (evt) {
            this._foundation.handleKeydown(evt);
        };
        MdcSelect.prototype.getSelectedIndex = function () {
            var _a, _b;
            return (_b = (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.getSelectedIndex()) !== null && _b !== void 0 ? _b : -1;
        };
        MdcSelect.prototype.focus = function () {
            this._selectAnchor.nativeElement.focus();
        };
        MdcSelect.prototype.setSelectedIndex = function (index) {
            var _a, _b;
            this.setSelectionByValue((_b = (_a = this._menu._list) === null || _a === void 0 ? void 0 : _a.getListItemByIndex(index)) === null || _b === void 0 ? void 0 : _b.value, true, index);
        };
        MdcSelect.prototype.setSelectionByValue = function (value, isUserInput, index) {
            if (isUserInput === void 0) { isUserInput = true; }
            var _a;
            if (!this._value && !value) {
                return;
            }
            if (!index) {
                index = (_a = this._menu._list) === null || _a === void 0 ? void 0 : _a.getListItemIndexByValue(value);
            }
            this._value = value;
            this._foundation.setSelectedIndex(index !== null && index !== void 0 ? index : -1, this._menu.closeSurfaceOnSelection);
            if (isUserInput) {
                this._onChange(this._value);
                this.selectionChange.emit(new MdcSelectChange(this, this.getSelectedIndex(), value));
            }
            this.valueChange.emit({
                index: this.getSelectedIndex(),
                value: this._value
            });
            this._syncHelperValidityState();
            this._foundation.handleChange();
            this._changeDetectorRef.markForCheck();
        };
        // Implemented as part of ControlValueAccessor.
        MdcSelect.prototype.setDisabledState = function (disabled) {
            var _a;
            this._disabled = coercion.coerceBooleanProperty(disabled);
            (_a = this._foundation) === null || _a === void 0 ? void 0 : _a.setDisabled(this._disabled);
            this._changeDetectorRef.markForCheck();
        };
        Object.defineProperty(MdcSelect.prototype, "_hasValue", {
            get: function () {
                var _a;
                return ((_a = this._value) === null || _a === void 0 ? void 0 : _a.length) > 0;
            },
            enumerable: true,
            configurable: true
        });
        /** Initialize Select internal state based on the environment state */
        MdcSelect.prototype.layout = function () {
            var _this = this;
            if (this._initialized) {
                this._asyncBuildFoundation().then(function () {
                    _this._selectBuilder();
                    _this._foundation.layout();
                });
            }
        };
        MdcSelect.prototype._initializeSelection = function () {
            var _this = this;
            // Defer setting the value in order to avoid the "Expression
            // has changed after it was checked" errors from Angular.
            Promise.resolve().then(function () {
                var _a, _b;
                var value = (_b = (_a = _this.ngControl) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : _this._value;
                if (value) {
                    _this.setSelectionByValue(value, false);
                }
            });
        };
        /** Set the default options. */
        MdcSelect.prototype._setDefaultGlobalOptions = function () {
            if (this._defaults) {
                if (this._defaults.outlined != null) {
                    this.outlined = this._defaults.outlined;
                }
            }
        };
        MdcSelect.prototype._asyncBuildFoundation = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this._foundation = this.getDefaultFoundation();
                    return [2 /*return*/];
                });
            });
        };
        MdcSelect.prototype._asyncInitFoundation = function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this._foundation.init();
                    return [2 /*return*/];
                });
            });
        };
        MdcSelect.prototype._selectBuilder = function () {
            var _this = this;
            this._changeDetectorRef.detectChanges();
            // initialize after running a detectChanges()
            this._asyncInitFoundation()
                .then(function () {
                if (!_this.outlined) {
                    _this._ripple = _this._createRipple();
                    _this._ripple.init();
                }
                _this._menu.wrapFocus = false;
                _this._menu.elementRef.nativeElement.setAttribute('role', 'listbox');
                _this._menu.elementRef.nativeElement.classList.add('mdc-select__menu');
                if (_this._menu._list) {
                    _this._menu._list.useSelectedClass = true;
                    _this._menu._list.singleSelection = true;
                }
            });
        };
        MdcSelect.prototype._subscribeToMenuEvents = function () {
            var _this = this;
            // When the list items change, re-subscribe
            this._menu._list.items.changes.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function () { return _this._initializeSelection(); });
            // Subscribe to menu opened event
            this._menu.opened.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function () { return _this._foundation.handleMenuOpened(); });
            // Subscribe to menu closed event
            this._menu.closed.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function () {
                _this._foundation.handleMenuClosed();
                _this._blur();
            });
            // Subscribe to list-item action event
            this._menu.selected.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function (evt) { return _this.setSelectedIndex(evt.index); });
        };
        MdcSelect.prototype._blur = function () {
            this._onTouched();
            this.blur.emit(this.value);
            this._onFocus.emit(false);
            this._syncHelperValidityState();
        };
        MdcSelect.prototype._isValid = function () {
            return (!!this.validationMessage && !this._hasValue && this.required) || this.errorState;
        };
        MdcSelect.prototype._getFloatingLabel = function () {
            var _a, _b;
            return (_a = this._floatingLabel) !== null && _a !== void 0 ? _a : (_b = this._notchedOutline) === null || _b === void 0 ? void 0 : _b.floatingLabel;
        };
        MdcSelect.prototype._syncHelper = function () {
            var _a;
            if (this._shouldRenderHelperText()) {
                this._initHelperFoundation();
            }
            this._foundationHelper.setContent((_a = this.helper) !== null && _a !== void 0 ? _a : '');
            this._foundationHelper.setPersistent(this._helperPersistent);
        };
        MdcSelect.prototype._syncHelperValidityState = function () {
            var _a, _b, _c, _d;
            var showValidationMessage = this._isValid();
            if (this._shouldRenderHelperText()) {
                (_a = this._foundationHelper) === null || _a === void 0 ? void 0 : _a.setContent(showValidationMessage ? (_b = this.validationMessage) !== null && _b !== void 0 ? _b : '' : (_c = this.helper) !== null && _c !== void 0 ? _c : '');
                (_d = this._foundationHelper) === null || _d === void 0 ? void 0 : _d.setValidation(showValidationMessage);
            }
        };
        MdcSelect.prototype._initHelperFoundation = function () {
            if (!this._foundationHelper) {
                this._foundationHelper = new MdcSelectHelperTextFoundation(this._elementRef, this._document);
                this._foundationHelper.init();
            }
        };
        MdcSelect.prototype._shouldRenderHelperText = function () {
            return !!this.helper || !!this.validationMessage;
        };
        /**
         * Calculates where the line ripple should start based on the x coordinate within the component.
         */
        MdcSelect.prototype._getNormalizedXCoordinate = function (evt) {
            var targetClientRect = evt.target.getBoundingClientRect();
            if (evt instanceof MouseEvent) {
                return evt.clientX - targetClientRect.left;
            }
            var clientX = evt.touches[0] && evt.touches[0].clientX;
            return clientX - targetClientRect.left;
        };
        MdcSelect.prototype._createRipple = function () {
            var _this = this;
            var adapter = __assign(__assign({}, MdcRipple.createAdapter({ _root: this._selectAnchor.nativeElement })), { registerInteractionHandler: function (evtType, handler) {
                    return _this._selectAnchor.nativeElement.addEventListener(evtType, handler);
                }, deregisterInteractionHandler: function (evtType, handler) {
                    return _this._selectAnchor.nativeElement.removeEventListener(evtType, handler);
                } });
            return new MdcRipple(this._selectAnchor, new ripple.MDCRippleFoundation(adapter));
        };
        MdcSelect.decorators = [
            { type: i0.Component, args: [{
                        selector: 'mdc-select',
                        exportAs: 'mdcSelect',
                        host: {
                            '[id]': 'id',
                            'class': 'mdc-select',
                            '[class.mdc-select--disabled]': 'disabled',
                            '[class.mdc-select--outlined]': 'outlined',
                            '[class.mdc-select--required]': 'required',
                            '[class.mdc-select--no-label]': '!_hasPlaceholder',
                            '[class.mdc-select--with-leading-icon]': 'leadingIcon',
                            '[class.mdc-select--invalid]': 'errorState'
                        },
                        template: "<div #selectAnchor class=\"mdc-select__anchor\"\r\n  role=\"button\"\r\n  aria-haspopup=\"listbox\"\r\n  [tabindex]=\"disabled ? '-1' : '0'\"\r\n  [attr.aria-required]=\"required\"\r\n  [attr.aria-labelledby]=\"placeholder\"\r\n  (focus)=\"onFocus()\"\r\n  (blur)=\"onBlur()\"\r\n  (keydown)=\"onKeydown($event)\"\r\n  (click)=\"onClick($event)\">\r\n  <span class=\"mdc-select__ripple\" *ngIf=\"!outlined\"></span>\r\n  <ng-content select=\"mdc-icon\"></ng-content>\r\n  <input #selectSelectedText class=\"mdc-select__selected-text\"\r\n    type=\"text\"\r\n    disabled\r\n    readonly\r\n    [value]=\"_selectedText\" />\r\n    <i class=\"mdc-select__dropdown-icon\"></i>\r\n    <label mdcFloatingLabel *ngIf=\"!outlined\" [for]=\"id\">{{placeholder}}</label>\r\n    <mdc-line-ripple *ngIf=\"!outlined\"></mdc-line-ripple>\r\n    <mdc-notched-outline *ngIf=\"outlined\" [label]=\"placeholder\" [for]=\"id\"></mdc-notched-outline>\r\n</div>\r\n<ng-content select=\"mdc-menu\"></ng-content>\r\n",
                        providers: [
                            MdcRipple,
                            { provide: MdcFormFieldControl, useExisting: MdcSelect }
                        ],
                        encapsulation: i0.ViewEncapsulation.None,
                        changeDetection: i0.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        /** @nocollapse */
        MdcSelect.ctorParameters = function () { return [
            { type: platform.Platform },
            { type: i0.ChangeDetectorRef },
            { type: i0.ElementRef },
            { type: ErrorStateMatcher },
            { type: undefined, decorators: [{ type: i0.Inject, args: [common.DOCUMENT,] }] },
            { type: MdcFormField, decorators: [{ type: i0.Optional }] },
            { type: MdcRipple, decorators: [{ type: i0.Optional }] },
            { type: forms.NgControl, decorators: [{ type: i0.Self }, { type: i0.Optional }] },
            { type: forms.NgForm, decorators: [{ type: i0.Optional }] },
            { type: forms.FormGroupDirective, decorators: [{ type: i0.Optional }] },
            { type: undefined, decorators: [{ type: i0.Optional }, { type: i0.Inject, args: [MDC_SELECT_DEFAULT_OPTIONS,] }] }
        ]; };
        MdcSelect.propDecorators = {
            id: [{ type: i0.Input }],
            name: [{ type: i0.Input }],
            helper: [{ type: i0.Input }],
            validationMessage: [{ type: i0.Input }],
            placeholder: [{ type: i0.Input }],
            disabled: [{ type: i0.Input }],
            outlined: [{ type: i0.Input }],
            required: [{ type: i0.Input }],
            valid: [{ type: i0.Input }],
            compareWith: [{ type: i0.Input }],
            value: [{ type: i0.Input }],
            helperPersistent: [{ type: i0.Input }],
            errorStateMatcher: [{ type: i0.Input }],
            selectionChange: [{ type: i0.Output }],
            valueChange: [{ type: i0.Output }],
            blur: [{ type: i0.Output }],
            _onFocus: [{ type: i0.Output, args: ['focus',] }],
            _floatingLabel: [{ type: i0.ViewChild, args: [MdcFloatingLabel, { static: false },] }],
            _lineRipple: [{ type: i0.ViewChild, args: [MdcLineRipple, { static: false },] }],
            _notchedOutline: [{ type: i0.ViewChild, args: [MdcNotchedOutline, { static: false },] }],
            _selectAnchor: [{ type: i0.ViewChild, args: ['selectAnchor', { static: false },] }],
            _selectSelectedText: [{ type: i0.ViewChild, args: ['selectSelectedText', { static: true },] }],
            _menu: [{ type: i0.ContentChild, args: [MdcMenu, { static: false },] }],
            leadingIcon: [{ type: i0.ContentChild, args: [MdcSelectIcon, { static: false },] }]
        };
        return MdcSelect;
    }(_MdcSelectMixinBase));

    var SELECT_DECLARATIONS = [
        MdcSelect,
        MdcSelectIcon,
    ];
    var MdcSelectModule = /** @class */ (function () {
        function MdcSelectModule() {
        }
        MdcSelectModule.decorators = [
            { type: i0.NgModule, args: [{
                        imports: [
                            common.CommonModule,
                            MdcMenuModule,
                            MdcListModule,
                            MdcFormFieldModule,
                            MdcFloatingLabelModule,
                            MdcNotchedOutlineModule,
                            MdcLineRippleModule
                        ],
                        exports: [
                            MdcMenuModule,
                            MdcListModule,
                            MdcFormFieldModule,
                            SELECT_DECLARATIONS
                        ],
                        declarations: SELECT_DECLARATIONS
                    },] }
        ];
        return MdcSelectModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MDC_SELECT_DEFAULT_OPTIONS = MDC_SELECT_DEFAULT_OPTIONS;
    exports.MdcSelect = MdcSelect;
    exports.MdcSelectChange = MdcSelectChange;
    exports.MdcSelectIcon = MdcSelectIcon;
    exports.MdcSelectModule = MdcSelectModule;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-select.umd.js.map
